const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const shopLogoUrl = (shop) =>
  `${BACKEND}/api/shop/logo?v=${encodeURIComponent(shop?.logo_path || "")}`;
